import { get } from '../../shared/utils/fetch.util'

export const fetchMembers = () => get('/v2/config/members')
